<template>
    <div>
        <label class="switch" @click.prevent="onToggle">
            <input type="checkbox" :checked="value" tabindex="-1" />
            <span class="slider round"></span>
        </label>
    </div>
</template>
<script>
export default {
    name: "CustomSwitchFilterNew",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        clickAction: {
            type: Function,
            default: () => { }
        }
    },
    methods: {
        onToggle() {
            this.$emit('input', !this.value)
            this.clickAction()
        }
    }
}
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 46px;
    height: 27px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e7e7e7;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 23px;
    width: 23px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked+.slider {
    background-color: var(--color-main);
}

input:focus+.slider {
    box-shadow: 0 0 1px var(--color-main);
}

input:checked+.slider:before {
    -webkit-transform: translateX(18px);
    -ms-transform: translateX(18px);
    transform: translateX(18px);
}

.slider.round {
    border-radius: 40px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>